export class DownloadItem {
  constructor() {}

  itemId: string;
  name: string;
  picture: string;
  isMovie: boolean;
  downloadUrl: string;
}



// WEBPACK FOOTER //
// ./src/data/DownloadItem.ts